/**
 * Cookie names aligned with the backend `HeaderCookieName` enum so the SPA and BFF stay in sync.
 */

export const HeaderCookieName = {
  XSRF_TOKEN_COOKIE: 'XSRF-TOKEN',
  // Double-submit CSRF: copy this value into `X-CSRF-TOKEN`. Must be readable from JS (not HttpOnly).
} as const
